import React, {useState} from "react";
import Button from "components/molecules/Button";
import {ManageStoreWrapper} from "components/atoms/Store/ManageStore/ManageStore.styles";
import {FaPlus} from "react-icons/fa";
import ManageBranches from "components/atoms/Store/ManageStore/ManageBranches";
import ModalContainer from "components/molecules/ModalContainer";
import AddNewBranch from "components/atoms/Store/ManageStore/AddNewBranch/Index";
import {useAuthContext} from "Context/authContext";
import {useSelector} from "react-redux";
import manageStores from "services/manageSores";
import ContentHeader from "components/atoms/ContentHeading/ContentHeader";
const ManageStores = () => {
        const businessId = useSelector(state => state.business.id);
        const { user } = useAuthContext();
        const businessIdFromAuth = user?.businessId;
        const business= businessIdFromAuth || businessId;
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [searchQuery, setSearchQuery] = useState({
        page: 1,
        itemsPerPage: 3,
        searchText: "",
        businessId: business,
    });
    
    const {stores_data, stores_loading} = manageStores.GetAllStores(searchQuery, refreshTrigger);
    const {hasPermission} = useAuthContext("hasPermission");

    const handleStoreCreated = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <>
            <ManageStoreWrapper>
                <div className="header">
                    <div className="left-warp">
                        <ContentHeader
                            title="Manage Stores"
                            para={`Total ${stores_data?.totalItems}`}
                            placeholder="Search in Stores"
                            showDateButton={false}
                            setSearchText={setSearchQuery}
                            setSearchQuery={setSearchQuery}
                            searchQuery={searchQuery}
                        />
                    </div>
                    {hasPermission("manage-stores.add-store") && (
                        <div className="btn-warp">
                            <ModalContainer
                                width={766}
                                title="Add New Store"
                                btnComponent={({onClick}) => (
                                    <Button onClick={onClick}>
                                        <span>
                                            <FaPlus />
                                        </span>
                                        Add New Store
                                    </Button>
                                )}
                                content={({onClose}) => <AddNewBranch 
                                    btnText="Add Store" 
                                    onClose={onClose}
                                    onStoreCreated={handleStoreCreated}
                                />}
                            />
                        </div>
                    )}
                </div>
                <ManageBranches
                    stores_data={stores_data}
                    stores_loading={stores_loading}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    onStoreUpdated={handleStoreCreated}
                />
            </ManageStoreWrapper>
        </>
    );
};

export default ManageStores;
